import { useContext, memo } from 'react';
import { useTranslation } from 'react-i18next';
import DataTable from '../../../DataTable/datatable.component';
import DateColumn from '../../../DataTable/datatable.datecolumn';
import { Link } from 'react-router-dom';
import { LotDetailContext } from '../../../Contexts/LotDetailContext';

const QIRSection = memo(function QIRSection() {

    const { t } = useTranslation();
    const { lotDetail: { qirs } } = useContext(LotDetailContext);

    const tableColumns = [
        {
            Header: t('LotDetails.QIRs.IncidentId'),
            accessor: 'incidentId',
            filter: 'includesString',
            Cell: (props) => {
                let qir = props.row.original;

                if (qir.url !== undefined && qir.url !== "") {
                    return <Link to={qir.url} target="_blank">{props.value}</Link>;
                }

                return props.value;
            }
        },
        DateColumn({ header: t('LotDetails.QIRs.IncidentDate'), accessor: 'incidentDateUtc' }),
        DateColumn({ header: t('LotDetails.QIRs.ReportedDate'), accessor: 'reportedDateUtc' }),
        DateColumn({ header: t('LotDetails.QIRs.EndDate'), accessor: 'endDateUtc' }),
        {
            Header: t('LotDetails.QIRs.Statement'),
            accessor: 'statement',
            filter: 'includesString'
        },
        {
            Header: t('LotDetails.QIRs.ReportedBy'),
            accessor: 'reportedBy',
            filter: 'includesString'
        }
    ];

    let table = DataTable({ tableColumns: tableColumns, tableData: qirs, initialState: {} });

    return qirs.length > 0 ? table : <>{t('CommonResponses.NoData')}</>;
});

export default QIRSection;